import { FC } from "react";
import parse from "html-react-parser";
import { BlockQuoteText, Cite, Quote } from "./Blockquote.styled";

type Props = {
  data: {
    cite?: string;
    markup?: string;
  };
};

const Blockquote: FC<Props> = ({ data }) => {
  const { markup, cite } = data;
  if (!markup || !cite) {
    return null;
  }

  return (
    <>
      <Quote>“</Quote>
      <BlockQuoteText>{parse(markup)}</BlockQuoteText>
      <Cite>{cite}</Cite>
    </>
  );
};

export default Blockquote;
